/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import PageTitle from '../../../../client/js/components/PageTitle'
import { findManySettings } from '../../lib/rest/settingAPIClient'
import CompanySettingsForm from './CompanySettingsForm'
import { useQuery } from '@tanstack/react-query'
import LoadingHelper from '../../../../client/js/components/LoadingHelper'
import { Card, Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'
import BreadcrumbCard from '../../../../client/js/components/breadcrumb/BreadcrumbCard'
import AdminBreadcrumb from '../../../../client/js/components/breadcrumb/AdminBreadcrumb'

function CompanySettingsPage () {
  const intl = useIntl()

  const settingsQuery = useQuery({
    enabled: true,
    queryKey: ['settings'],
    queryFn: () => findManySettings(),
    refetchOnWindowFocus: false
  })

  const title = intl.formatMessage({
    id: 'company_settings',
    defaultMessage: 'Paramètres de la société'
  })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <BreadcrumbCard>
          <AdminBreadcrumb>
            <span>
              {intl.formatMessage({
                id: 'settings',
                defaultMessage: 'Paramètres'
              })}
            </span>
            <span>{title}</span>
          </AdminBreadcrumb>
        </BreadcrumbCard>

        <LoadingHelper
          always
          query={settingsQuery}
          render={() => (
            <Card shadow="sm">
              <CompanySettingsForm initialValues={settingsQuery.data} />
            </Card>
          )}
        />
      </Container>
    </Page>
  )
}

export default CompanySettingsPage
